import { IDropdownItem } from "./dropdown.interface";
import { sortArray } from "../shared.utils";
// eslint-disable-next-line max-len

const nationalitiesDescription = [
  "Abkhazian",
  "Afghan",
  "Albanian",
  "Algerian",
  "American Samoan",
  "American,U.S",
  "Andorran",
  "Angolan",
  "Anguillan",
  "Antiguan and Barbudan",
  "Argentine",
  "Armenian",
  "Aruban",
  "Australian",
  "Austrian",
  "Azerbaijani",
  "Bahamian",
  "Bahraini",
  "Bangladeshi",
  "Barbadian",
  "Basotho",
  "Belarusian",
  "Belgian",
  "Belizean",
  "Beninese",
  "Bermudian",
  "Bhutanese",
  "Bolivian",
  "Bosnian",
  "Brazilian",
  "British",
  "British Virgin Island",
  "Bruneian",
  "Bulgarian",
  "Burkinabè",
  "Burmese",
  "Burundian",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Cape Verdean",
  "Caymanian",
  "Central African",
  "Chadian",
  "Chilean",
  "Chinese",
  "Christmas Island",
  "Cocos Island",
  "Colombian",
  "Comorian",
  "Congo",
  "Congo BZ",
  "Congolese",
  "Cook Island",
  "Costa Rican",
  "Croatian",
  "Cuban",
  "Cypriot",
  "Czech",
  "Danish",
  "Djiboutian",
  "Dominicand",
  "Dominicane",
  "Dutch",
  "Ecuadorian",
  "Egyptian",
  "Emirati",
  "English",
  "Equatoguinean",
  "Eritrean",
  "Estonian",
  "Ethiopian",
  "Falkland Island",
  "Faroese",
  "Fijian",
  "Filipino",
  "Finnish",
  "French",
  "French Guianese",
  "French Polynesian",
  "Gabonese",
  "Gambian",
  "Georgian",
  "German",
  "Ghanaian",
  "Gibraltar",
  "Greek",
  "Greenlandic",
  "Grenadian",
  "Guadeloupe",
  "Guamanian",
  "Guatemalan",
  "Guinean",
  "Guyanese",
  "Haitian",
  "Honduran",
  "Hongkongese",
  "Hungarian",
  "I-Kiribati",
  "Icelandic",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Ivorian",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kazakhstani",
  "Kenyan",
  "Kittitian and Nevisian",
  "Kosovar",
  "Kuwaiti",
  "Kyrgyz",
  "Laotian",
  "Latvian",
  "Lebanese",
  "Liberian",
  "Libyan",
  "Liechtenstein",
  "Lithuanian",
  "Luxembourgish",
  "Macedonian",
  "Mahoran",
  "Malagasy",
  "Malawian",
  "Malaysian",
  "Maldivian",
  "Malian",
  "Maltese",
  "Manx",
  "Marshallese",
  "Martiniquais",
  "Mauritanian",
  "Mauritian",
  "Mexican",
  "Micronesian",
  "Moldovan",
  "Monegasque",
  "Mongolian",
  "Montenegrin",
  "Montserratian",
  "Moroccan",
  "Motswana",
  "Mozambican",
  "Namibian",
  "Nauruan",
  "Nepali",
  "New Caledonian",
  "New Zealand",
  "Nicaraguan",
  "Nigerien",
  "Nigerian",
  "Niuean",
  "None",
  "North Korean",
  "Northern Marianan",
  "Norwegian",
  "Omani",
  "Pakistani",
  "Palauan",
  "Palestinian",
  "Panamanian",
  "Papua New Guinean",
  "Paraguayan",
  "Peruvian",
  "Pitcairn Island",
  "Polish",
  "Portuguese",
  "Puerto Rican",
  "Qatari",
  "Reunionese",
  "Romanian",
  "Russian",
  "Rwandan",
  "Sahrawian",
  "Saint-Pierrais and Miquelonnais",
  "Salvadoran",
  "Sammarinese",
  "Samoan",
  "Saudi",
  "Scottish",
  "Senegalese",
  "Serbian",
  "Seychellois",
  "Sierra Leonean",
  "Singaporean",
  "Slovak",
  "Slovenian",
  "Solomon Island",
  "Somali",
  "South African",
  "South Korean",
  "South Ossetian",
  "South Sudanese",
  "Spanish",
  "Sri Lankan",
  "St. Helenian",
  "St. Lucian",
  "Sudanese",
  "Surinamese",
  "Swazi",
  "Swedish",
  "Swiss",
  "Syrian",
  "Szo Tomean",
  "Taiwanese",
  "Tajikistani",
  "Tanzanian",
  "Thai",
  "Timorese",
  "Togolese",
  "Tongan",
  "Trinidadian and Tobagonian",
  "Tunisian",
  "Turkish",
  "Turkmen",
  "Tuvaluan",
  "Ugandan",
  "Ukrainian",
  "Uruguayan",
  "Uzbekistani",
  "Venezuelan",
  "Vietnamese",
  "Vincentian",
  "Virgin Island",
  "Wallisian and Futunan",
  "Welsh",
  "Yemeni",
  "Zambian",
  "Zimbabwean",
];

export const NATIONALITIES = sortArray(
  nationalitiesDescription.map((item, index) => ({
    id: index,
    key: `citizen.${index}`,
    description: item.toUpperCase(),
  })),
  "description",
);

const FALLBACK_NATIONALITY = {
  id: -1,
  key: "generalInformation.fallbackCitizen",
};

const DEFAULT_NATIONALITY_KEY = 40;

export const PROVINCES: IDropdownItem[] = [
  { id: 0, key: "province.0", description: "BAS UELE" },
  { id: 1, key: "province.1", description: "EQUATEUR" },
  { id: 2, key: "province.2", description: "HAUT KATANGA" },
  { id: 3, key: "province.3", description: "HAUT LOMAMI" },
  { id: 4, key: "province.4", description: "HAUT UELE" },
  { id: 5, key: "province.5", description: "ITURI" },
  { id: 6, key: "province.6", description: "KASAI" },
  { id: 7, key: "province.7", description: "KASAI CENTRAL" },
  { id: 8, key: "province.8", description: "KASAI ORIENTAL" },
  { id: 9, key: "province.9", description: "KINSHASA" },
  { id: 10, key: "province.10", description: "KONGO-CENTRAL" },
  { id: 11, key: "province.11", description: "KWANGO" },
  { id: 12, key: "province.12", description: "KWILU" },
  { id: 13, key: "province.13", description: "LOMAMI" },
  { id: 14, key: "province.14", description: "LUALABA" },
  { id: 15, key: "province.15", description: "MAI NDOMBE" },
  { id: 16, key: "province.16", description: "MANIEMA" },
  { id: 17, key: "province.17", description: "MONGALA" },
  { id: 18, key: "province.18", description: "NORD KIVU" },
  { id: 19, key: "province.19", description: "NORD UBANGI" },
  { id: 20, key: "province.20", description: "SANKURU" },
  { id: 21, key: "province.21", description: "SUD KIVU" },
  { id: 22, key: "province.22", description: "SUD UBANGI" },
  { id: 23, key: "province.23", description: "TANGANYIKA" },
  { id: 24, key: "province.24", description: "TSHOPO" },
  { id: 25, key: "province.25", description: "TSHUAPA" },
];

const FALLBACK_PROVINCE: IDropdownItem = {
  id: -2,
  key: "generalInformation.fallbackProvince",
  description: "PROVINCE",
};

export const townsDescription = [
  { description: "AKETI", provinceID: 0, id: 0 },
  { description: "ARU", provinceID: 5, id: 1 },
  { description: "BAKWA-KALONJI (LUKALABA)", provinceID: 8, id: 2 },
  { description: "BALAMBA (KASUMBALESA)", provinceID: 2, id: 3 },
  { description: "BANDUNDU", provinceID: 12, id: 4 },
  { description: "BASANKUSU", provinceID: 1, id: 5 },
  { description: "BASOKO (INCL. BANDU)", provinceID: 24, id: 6 },
  { description: "BENI", provinceID: 18, id: 7 },
  { description: "BINGA", provinceID: 17, id: 8 },
  { description: "BOENDE", provinceID: 25, id: 9 },
  { description: "BOLOBO", provinceID: 15, id: 10 },
  { description: "BOMA", provinceID: 10, id: 11 },
  { description: "BUKAMA (INCL. KIBANDA)", provinceID: 3, id: 12 },
  { description: "BUKAVU", provinceID: 21, id: 13 },
  { description: "BULUNGU", provinceID: 12, id: 14 },
  { description: "BUMBA", provinceID: 17, id: 15 },
  { description: "BUNIA", provinceID: 5, id: 16 },
  { description: "BUSINGA", provinceID: 19, id: 17 },
  { description: "BUTA", provinceID: 0, id: 18 },
  { description: "BUTEMBO", provinceID: 18, id: 19 },
  { description: "DIYABA-LUBUE", provinceID: 12, id: 20 },
  { description: "DJUGU", provinceID: 5, id: 21 },
  { description: "DUNGU", provinceID: 4, id: 22 },
  { description: "FUNGURUME", provinceID: 14, id: 23 },
  { description: "GANDAJIKA", provinceID: 13, id: 24 },
  { description: "GBADOLITE", provinceID: 19, id: 25 },
  { description: "GEMENA", provinceID: 22, id: 26 },
  { description: "GOMA", provinceID: 18, id: 27 },
  { description: "IDIOFA", provinceID: 12, id: 28 },
  { description: "ILEBO", provinceID: 6, id: 29 },
  { description: "INKISI (KISANTU)", provinceID: 10, id: 30 },
  { description: "INONGO", provinceID: 15, id: 31 },
  { description: "ISIRO", provinceID: 4, id: 32 },
  { description: "KABALO", provinceID: 23, id: 33 },
  { description: "KABINDA", provinceID: 13, id: 34 },
  { description: "KALEMIE", provinceID: 23, id: 35 },
  { description: "KALIMA", provinceID: 16, id: 36 },
  { description: "KAMBOVE", provinceID: 2, id: 37 },
  { description: "KAMINA", provinceID: 3, id: 38 },
  { description: "KANANGA", provinceID: 7, id: 39 },
  { description: "KANIAMA", provinceID: 3, id: 40 },
  { description: "KANYABAYONGA", provinceID: 18, id: 41 },
  { description: "KASANGULU", provinceID: 10, id: 42 },
  { description: "KASONGO", provinceID: 16, id: 43 },
  { description: "KATANDA", provinceID: 8, id: 44 },
  { description: "KATWA", provinceID: 18, id: 45 },
  { description: "KAYNA", provinceID: 18, id: 46 },
  { description: "KENANKUNA (KABEYA)", provinceID: 8, id: 47 },
  { description: "KENGE", provinceID: 11, id: 48 },
  { description: "KIKWIT", provinceID: 12, id: 49 },
  { description: "KIMPESE", provinceID: 10, id: 50 },
  { description: "KINDU", provinceID: 16, id: 51 },
  { description: "KINSHASA", provinceID: 9, id: 52 },
  { description: "KIPAMBA (INCL. KIKONDJA)", provinceID: 3, id: 53 },
  { description: "KIPUSHI", provinceID: 2, id: 54 },
  { description: "KIRUMBA", provinceID: 18, id: 55 },
  { description: "KISANGANI", provinceID: 24, id: 56 },
  { description: "KITUKU", provinceID: 23, id: 57 },
  { description: "KOLWEZI", provinceID: 14, id: 58 },
  { description: "KONGOLO", provinceID: 23, id: 59 },
  { description: "KUTU", provinceID: 15, id: 60 },
  { description: "LIBENGE", provinceID: 22, id: 61 },
  { description: "LIKASI", provinceID: 2, id: 62 },
  { description: "LISALA", provinceID: 17, id: 63 },
  { description: "LODJA", provinceID: 20, id: 64 },
  { description: "LUBAO", provinceID: 13, id: 65 },
  { description: "LUBERO", provinceID: 18, id: 66 },
  { description: "LUBUMBASHI", provinceID: 2, id: 67 },
  { description: "LUEBO", provinceID: 6, id: 68 },
  { description: "LUKULA", provinceID: 10, id: 69 },
  { description: "LUPUTA", provinceID: 13, id: 70 },
  { description: "LUSAMBO", provinceID: 20, id: 71 },
  { description: "MALEMBA-NKULU", provinceID: 3, id: 72 },
  { description: "MANGAI", provinceID: 12, id: 73 },
  { description: "MANGINA (MATANGO)", provinceID: 18, id: 74 },
  { description: "MANONO", provinceID: 23, id: 75 },
  { description: "MASI-MANIMBA", provinceID: 12, id: 76 },
  { description: "MATADI", provinceID: 10, id: 77 },
  { description: "MBANDAKA", provinceID: 1, id: 78 },
  { description: "MBANZA-NGUNGU", provinceID: 10, id: 79 },
  { description: "MBUJI MAYI", provinceID: 8, id: 80 },
  { description: "MIABI", provinceID: 8, id: 81 },
  { description: "MOANDA", provinceID: 10, id: 82 },
  { description: "MOBA", provinceID: 23, id: 83 },
  { description: "MOKAMBO", provinceID: 2, id: 84 },
  { description: "MONGBWALU", provinceID: 5, id: 85 },
  { description: "MULONGO", provinceID: 3, id: 86 },
  { description: "MUSHIE", provinceID: 15, id: 87 },
  { description: "MWEKA", provinceID: 6, id: 88 },
  { description: "MWENE-DITU", provinceID: 13, id: 89 },
  { description: "NIOKI", provinceID: 15, id: 90 },
  { description: "NYUNZU", provinceID: 23, id: 91 },
  { description: "OICHA", provinceID: 18, id: 92 },
  { description: "PWETO", provinceID: 2, id: 93 },
  { description: "RUTSHURU", provinceID: 18, id: 94 },
  { description: "TSHELA", provinceID: 10, id: 95 },
  { description: "TSHIKAPA", provinceID: 6, id: 96 },
  { description: "TSHILENGE", provinceID: 8, id: 97 },
  { description: "UVIRA", provinceID: 21, id: 98 },
  { description: "WATSA", provinceID: 4, id: 99 },
  { description: "YANGAMBI", provinceID: 24, id: 100 },
  { description: "ZONGO", provinceID: 22, id: 101 },
];

export const OCCUPATIONS: IDropdownItem[] = [
  { id: 0, key: "occupation.0", description: "Artist/Liberal" },
  { id: 1, key: "occupation.1", description: "Athlète/Athlete" },
  { id: 2, key: "occupation.2", description: "Bettors/Casino gamblers" },
  { id: 3, key: "occupation.3", description: "Civil servant" },
  { id: 4, key: "occupation.4", description: "Comptable/Auditor" },
  { id: 5, key: "occupation.5", description: "Doctor/Nursing Staff" },
  { id: 6, key: "occupation.6", description: "Employee" },
  { id: 7, key: "occupation.7", description: "Jobless" },
  { id: 8, key: "occupation.8", description: "Lawyer/Judicial Staff/Notaries" },
  { id: 9, key: "occupation.9", description: "Merchant" },
  { id: 10, key: "occupation.10", description: "Personnel minier/Mining staff" },
  { id: 11, key: "occupation.11", description: "Police/Military" },
  { id: 12, key: "occupation.12", description: "Politician/Officials" },
  { id: 13, key: "occupation.13", description: "Real Estate Agent" },
  { id: 14, key: "occupation.14", description: "Religious staff" },
  { id: 15, key: "occupation.15", description: "Student/Pupil" },
];

export const IDCARDISSUEPLACE: IDropdownItem[] = [
  { id: 0, key: "idCardIssuePlace.0", description: "BAS UELE" },
  { id: 1, key: "idCardIssuePlace.1", description: "EQUATEUR" },
  { id: 2, key: "idCardIssuePlace.2", description: "HAUT KATANGA" },
  { id: 3, key: "idCardIssuePlace.3", description: "HAUT LOMAMI" },
  { id: 4, key: "idCardIssuePlace.4", description: "HAUT UELE" },
  { id: 5, key: "idCardIssuePlace.5", description: "ITURI" },
  { id: 6, key: "idCardIssuePlace.6", description: "KASAI" },
  { id: 7, key: "idCardIssuePlace.7", description: "KASAI CENTRAL" },
  { id: 8, key: "idCardIssuePlace.8", description: "KASAI ORIENTAL" },
  { id: 9, key: "idCardIssuePlace.9", description: "KINSHASA" },
  { id: 10, key: "idCardIssuePlace.10", description: "KONGO-CENTRAL" },
  { id: 11, key: "idCardIssuePlace.11", description: "KWANGO" },
  { id: 12, key: "idCardIssuePlace.12", description: "KWILU" },
  { id: 13, key: "idCardIssuePlace.13", description: "LOMAMI" },
  { id: 14, key: "idCardIssuePlace.14", description: "LUALABA" },
  { id: 15, key: "idCardIssuePlace.15", description: "MAI NDOMBE" },
  { id: 16, key: "idCardIssuePlace.16", description: "MANIEMA" },
  { id: 17, key: "idCardIssuePlace.17", description: "MONGALA" },
  { id: 18, key: "idCardIssuePlace.18", description: "NORD KIVU" },
  { id: 19, key: "idCardIssuePlace.19", description: "NORD UBANGI" },
  { id: 20, key: "idCardIssuePlace.20", description: "SANKURU" },
  { id: 21, key: "idCardIssuePlace.21", description: "SUD KIVU" },
  { id: 22, key: "idCardIssuePlace.22", description: "SUD UBANGI" },
  { id: 23, key: "idCardIssuePlace.23", description: "TANGANYIKA" },
  { id: 24, key: "idCardIssuePlace.24", description: "TSHOPO" },
  { id: 25, key: "idCardIssuePlace.25", description: "TSHUAPA" },
];

export const INCOME_RANGES: IDropdownItem[] = [
  { id: 0, key: "income.0", description: "0-100" },
  { id: 1, key: "income.1", description: "101-500" },
  { id: 2, key: "income.2", description: "501-2500" },
  { id: 3, key: "income.3", description: "2501-5000" },
  { id: 4, key: "income.4", description: "5001-10000" },
  { id: 5, key: "income.5", description: "10000+" },
];

export const RISK_RATINGS: IDropdownItem[] = [
  { id: 1, key: "risk.low", description: "Low Risk" },
  { id: 2, key: "risk.standard", description: "Medium Risk" },
  { id: 3, key: "risk.high", description: "High Risk" },
];

export interface ITown extends IDropdownItem {
  provinceID: number;
}

const TOWNS: ITown[] = townsDescription.map(town => ({
  id: town.id,
  key: `town.${town.id}`,
  description: town.description,
  provinceID: town.provinceID,
}));

const FALLBACK_TOWN = {
  id: -3,
  key: "generalInformation.fallbackTown",
  description: "TOWN",
  provinceID: -1,
};

export default {
  NATIONALITIES,
  FALLBACK_NATIONALITY,
  DEFAULT_NATIONALITY_KEY,
  PROVINCES,
  FALLBACK_PROVINCE,
  TOWNS,
  FALLBACK_TOWN,
  IDCARDISSUEPLACE,
  OCCUPATIONS,
  INCOME_RANGES,
  RISK_RATINGS,
};
